<template>
<div class="foot">
  <div class="foot-items">
    eScholar Uniq-ID® Version {{ $store.state.version }} | © 1997-{{ currentYear }} eScholar LLC, All Rights Reserved
  </div>
  <div class="foot-items" v-html="$store.state.footer"></div>
</div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      currentYear: null,
    };
  },
  mounted() {
    this.currentYear = moment().year();
  },
};
</script>

<style lang="sass" scoped>
  .foot
    padding: 0.5rem
    bottom: 0
    width: 100%
    display: block
    justify-content: center
    background-color: #fff
    box-shadow: 0 0 3px #aaa
    margin-top: auto
  .foot-items
    text-align: center
</style>
